export const importRunSortingColumns = [
    'createdAt',
    'insuranceCompany',
    'jobType',
    'success',
    'wallMs',
];
